export const GUEST_QUERY_KEY = {
  GUEST_LIST: (streamerId: string) => ['guestList', streamerId] as const,

  GUEST_REPLY_LIST: (streamerId: string, guestId: number) =>
    ['guestReplyList', streamerId, guestId] as const,

};
